import {
  faSave,
  faShieldAlt,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import React, { Component } from "react";
import Adjunto from "./formatos/Adjunto";
import {
  Container,
  Row,
  Col,
  Navbar,
  Button,
  Header,
  Nav,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faCamera } from "@fortawesome/free-solid-svg-icons";
import logo from "./img/logo_main_top_admin.png";
import { SpinnerComponent } from "react-element-spinner";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

export default class CargaQR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      frm_descripcion_doc: "",
      frm_archivo: null,
      api_token: "",
      usuario_id: "",
      ambito_id: "",
      formato_cve: "",
      fx_id: "",
      caducidad: "",
    };
  }

  componentDidMount = () => {
    this.cargaDatos();
  };

  cargaDatos = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/LeeQRToken/" +
        this.props.match.params.uuid,
      data: {},
    }).then((res) => {
      localStorage.setItem("api_token", res.data.api_token);
      this.setState({
        usuario_id: res.data.usuario_id,
        ambito_id: res.data.ambito_id,
        formato_cve: res.data.formato_cve,
        fx_id: res.data.fx_id,
        caducidad: res.data.caducidad,
        loading: false,
      });
    });
  };

  checaVigencia = () => { };

  onFileChange = (event) => {
    this.setState({
      frm_archivo: event.target.files[0],
    });
  };
  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };
  sube_documento = (e) => {
    e.preventDefault();
    if (this.state.frm_archivo == null) {
      toast.warn("Seleccione un archivo", { autoClose: 1500 });
    } else {
      if (this.state.frm_descripcion_doc == "") {
        toast.warn("Escriba una descripción", { autoClose: 1500 });
      } else {
        this.setState({ loading: true });
        let datosFormulario = new FormData();
        datosFormulario.append("archivo", this.state.frm_archivo);
        datosFormulario.append("descripcion", this.state.frm_descripcion_doc);
        datosFormulario.append("tipo", "jpg");
        datosFormulario.append("anexo_cve", this.state.formato_cve);
        datosFormulario.append("fx_id", this.state.fx_id);
        datosFormulario.append("ambito_id", this.state.ambito_id);
        datosFormulario.append("usuario_id", this.state.usuario_id);
        datosFormulario.append("api_token", localStorage.api_token);

        let config = {};
        axios
          .post(
            "http://143.198.191.211/api/Documento/",
            datosFormulario,
            config
          )
          .then((res) => {
            toast.success(res.data.text, { autoClose: 1000 });
            this.setState({
              frm_archivo: null,
              frm_descripcion_doc: "",
            });

            this.setState({ loading: false });
          });
      }
    }
  };

  render() {
    return (
      <div>
        <ToastContainer />
        <SpinnerComponent
          loading={this.state.loading}
          position="global"
          color="#f7e333"
        />
        <Navbar bg="primary" variant="dark">
          <Navbar.Brand href="#home">
            <img src={logo} style={{ maxHeight: 40 }} /> Entrega Recepción
          </Navbar.Brand>
        </Navbar>

        <Container fluid>
          <Row className="mt-2">
            <Col>
              <h3>Carga rapida de documentos</h3>
            </Col>
          </Row>

          <Row>
            <Col>
              <label htmlFor="file-upload" className="custom-file-upload-movil">
                <FontAwesomeIcon icon={faUpload} /> Seleccionar Archivo PDF o
                Imagen
              </label>
              <input
                id="file-upload"
                type="file"
                onChange={this.onFileChange}
                accept="image/png, image/jpeg, application/pdf"
                className="btnSubir"
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Form.Label>Descripcion del Archivo:</Form.Label>
              <Form.Control
                type="text"
                name="frm_descripcion_doc"
                onChange={this.onChangefrm_descripcion_doc}
                value={this.state.frm_descripcion_doc}
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Button
                size="lg"
                block
                onClick={this.sube_documento}
                disabled={this.state.loading}
              >
                <FontAwesomeIcon icon={faSave} />
                &nbsp;Guardar
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
/*
ambito_id es: {this.props.match.params.ambito_id}
              formato: {this.props.match.params.formato_cve}
              id registro: {this.props.match.params.id_registro}
*/
